<ion-header class="ion-no-border">

  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="close()">
        <fa-icon [icon]="['far', 'times']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>Filter quotes</ion-title>
    @if (online && !loading) {
      <ion-buttons slot="end">
        <ion-button (click)="clearFilters()">
          <fa-icon [icon]="['far', 'trash-alt']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
          <span>Clear</span>
        </ion-button>
        <ion-button (click)="filter()">
          <fa-icon [icon]="['far', 'check']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
        </ion-button>
      </ion-buttons>
    }
  </ion-toolbar>

</ion-header>

<ion-content>

  @if (online && !loading) {
    <ion-grid class="form">
      <ion-row>
        <ion-col>
          <ion-grid class="fieldset">
            <ion-row>
              <ion-col>
                <ion-select cancelText="Clear" okText="OK" interface="alert" [interfaceOptions]="status_options" (ionCancel)="clearStatus()" labelPlacement="stacked" fill="outline" [(ngModel)]="filter_params['status']">
                  <div slot="label">Status<ion-text class="optional">optional</ion-text></div>
                  <ion-select-option value="draft">Draft</ion-select-option>
                  <ion-select-option value="sent">Sent</ion-select-option>
                  <ion-select-option value="declined">Declined</ion-select-option>
                  <ion-select-option value="accepted">Accepted</ion-select-option>
                  <ion-select-option value="cancelled">Cancelled</ion-select-option>
                  <ion-select-option value="ordered">Ordered</ion-select-option>
                </ion-select>
              </ion-col>
            </ion-row>
            @if (supported_currencies && supported_currencies.length != 0) {
              <ion-row>
                <ion-col>
                  <ion-select cancelText="Clear" okText="OK" interface="alert" [interfaceOptions]="currency_options" (ionCancel)="clearCurrency()" labelPlacement="stacked" fill="outline" [(ngModel)]="filter_params['currency_id']">
                    <div slot="label">Currency<ion-text class="optional">optional</ion-text></div>
                    @for (currency of supported_currencies; track currency) {
                      <ion-select-option value="{{currency.id}}">{{currency.title}}</ion-select-option>
                    }
                  </ion-select>
                </ion-col>
              </ion-row>
            }
            @if (pricing_tiers && pricing_tiers.length != 0) {
              <ion-row>
                <ion-col>
                  <ion-select cancelText="Clear" okText="OK" interface="alert" [interfaceOptions]="pricing_tier_options" (ionCancel)="clearPricingTier()" labelPlacement="stacked" fill="outline" [(ngModel)]="filter_params['pricing_tier_id']">
                    <div slot="label">Pricing tier<ion-text class="optional">optional</ion-text></div>
                    @for (pricing_tier of pricing_tiers; track pricing_tier) {
                      @if (pricing_tier.sellable == true) {
                        <ion-select-option value="{{pricing_tier.id}}">{{pricing_tier.title}}</ion-select-option>
                      }
                    }
                  </ion-select>
                </ion-col>
              </ion-row>
            }
            <ion-row>
              <ion-col>
                @if (organisation_title) {
                  <ion-input class="modal-input" readonly="true" labelPlacement="stacked" fill="outline" value={{organisation_title}} (click)="presentOrganisationPickerModal()">
                    <div slot="label">Organisation<ion-text class="optional">optional</ion-text></div>
                  </ion-input>
                }
                @if (!organisation_title) {
                  <ion-input class="modal-input" readonly="true" labelPlacement="stacked" fill="outline" (click)="presentOrganisationPickerModal()">
                    <div slot="label">Organisation<ion-text class="optional">optional</ion-text></div>
                  </ion-input>
                }
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col>
                <ion-select cancelText="Clear" okText="OK" interface="alert" [interfaceOptions]="archived_options" (ionCancel)="clearArchived()" labelPlacement="stacked" fill="outline" [(ngModel)]="filter_params['archived']">
                  <div slot="label">Archived<ion-text class="optional">optional</ion-text></div>
                  <ion-select-option [value]="false">No</ion-select-option>
                  <ion-select-option [value]="true">Yes</ion-select-option>
                </ion-select>
              </ion-col>
            </ion-row>
          </ion-grid>
        </ion-col>
      </ion-row>
    </ion-grid>
  }

</ion-content>